export const endpoints = {
  getAll: () => "api/v1/internal/workflows",
  get: (code: string) => `api/v1/internal/workflows/${code}`,
  getStates: (code: string) => `api/v1/internal/workflows/${code}/states`,
  getJson: (code: string) => `api/v1/internal/workflows/${code}/json`,
  updateJson: (code: string) => `api/v1/internal/workflows/${code}/json`,
  checkFeedbackDisplacedByJsonUpdate: (code: string) =>
    `api/v1/internal/workflows/${code}/json/displacedcount`,
  createTemplate: () => "api/v1/internal/workflows/templates",
  deleteTemplate: (code: string) => `api/v1/internal/workflows/templates/${code}`,
  options: () => "api/v1/internal/workflows/options",
  images: () => "api/v1/internal/workflows/images",
  getAllTriggers: () => "api/v1/internal/workflows/triggers"
};
